import { ViewResolver } from '@Components/ViewResolver';
import { useGetLatestUpdatesQuery } from '@Store/api/strapiApiSlice';
import LatestUpdatesDesktop from './desktop';
import LatestUpdatesMobile from './mobile';

const LatestUpdates: React.FC = () => {
  const { data } = useGetLatestUpdatesQuery();
  return (
    <ViewResolver
      desktop={<LatestUpdatesDesktop latestUpdates={data} />}
      mobile={<LatestUpdatesMobile latestUpdates={data} />}
    />
  );
};

export default LatestUpdates;
